export const CAPTAIN_UNAVAILABLE_MESSAGE =
  'Virtual Assistant is not available currently, please try again.';

export const CAPTAIN_ORDER_TYPE_MESSAGE = 'Would you like Dine-in or Take-away?';

const TECHNICAL_PATTERNS = [
  /^Backend error \d+$/i,
  /^HTTP \d+/i,
  /OpenAI not configured/i,
  /Conversation failed/i,
  /Invalid JSON/i,
  /Missing restaurantId/i,
  /Invalid auth token/i,
  /Empty message/i,
  /MongoDB not connected/i,
  /ECONNREFUSED/i,
  /fetch failed/i,
  /Internal Server Error/i,
  /NetworkError/i,
  /please ask the customer/i,
];

/** Map raw Captain / backend errors to customer-safe chat copy. */
export function formatCaptainErrorMessage(raw?: string | null): string {
  const message = raw?.trim();
  if (!message) return CAPTAIN_UNAVAILABLE_MESSAGE;

  if (/please ask the customer/i.test(message)) {
    return CAPTAIN_ORDER_TYPE_MESSAGE;
  }
  if (TECHNICAL_PATTERNS.some((pattern) => pattern.test(message))) {
    return CAPTAIN_UNAVAILABLE_MESSAGE;
  }
  if (/error\s*\d{3}/i.test(message)) return CAPTAIN_UNAVAILABLE_MESSAGE;
  if (message.length > 120) return CAPTAIN_UNAVAILABLE_MESSAGE;

  return message;
}

const STATUS_CODE_LABELS: Record<string, string> = {
  ORDER_PLACED: 'Order Placed',
  ORDER_MODIFIED: 'Order Modified',
  ORDER_CONFIRMED: 'Order Confirmed',
  ORDER_PREPARING: 'Preparing Your Food',
  ORDER_PREPARED: 'Ready to Serve',
  ORDER_SERVED: 'Served',
  ORDER_PICKED: 'Ready for Pickup',
  ORDER_COMPLETED: 'Completed',
  DINEIN_ORDER_COMPLETED: 'Completed',
  TAKEAWAY_ORDER_COMPLETED: 'Completed',
  DELIVERY_ORDER_COMPLETED: 'Completed',
  ORDER_CANCELLED: 'Cancelled',
};

/** Replace raw ALL_CAPS status codes the LLM may echo verbatim in its reply. */
function replaceStatusCodes(text: string): string {
  return text.replace(/\bORDER_[A-Z_]+\b|\b(?:DINEIN|TAKEAWAY|DELIVERY)_ORDER_[A-Z_]+\b/g, (match) => {
    return STATUS_CODE_LABELS[match] ?? match.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
  });
}

/** Rewrite internal LLM instructions if they leak into on-screen chat copy. */
export function sanitizeCaptainDisplayText(text: string): string {
  let trimmed = text.trim();
  if (!trimmed) return trimmed;
  if (/please ask the customer/i.test(trimmed)) {
    return CAPTAIN_ORDER_TYPE_MESSAGE;
  }
  trimmed = replaceStatusCodes(trimmed);
  return trimmed;
}
